import {required} from "vuelidate/lib/validators";  
const activitytranslations = {
    data() { 
      return {   
        activitytranslationsData: { 
          Title: "", 
          Description: "",  
          SeoTitle: "", 
          SeoKeywords: "", 
          SeoDescription: "", 
          Activityid: "",
          Langid: "",
          Websiteid: "", 
          Deleted: false, 
          },      

          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('dpages.AddEdit.Title')},  
            Description:{FieldName:"Description",Field:"input",FieldTitle:this.$t('dpages.AddEdit.Description')},  
            SeoTitle:{FieldName:"SeoTitle",Field:"input",FieldTitle:this.$t('dpages.AddEdit.SeoTitle')}, 
            SeoKeywords:{FieldName:"SeoKeyword",Field:"input",FieldTitle:this.$t('dpages.AddEdit.SeoKeyword')}, 
            SeoDescription:{FieldName:"SeoDescription",Field:"input",FieldTitle:this.$t('dpages.AddEdit.SeoDescription')}, 
            Langid:{FieldName:"Dpageid",Field:"input"}, 
            Activityid:{FieldName:"Newsid",Field:"input"}, 
            Websiteid:{FieldName:"Websiteid",Field:"input"},        
          } 
      }
    },  
    validations:{ 
      FormData: {  
        Title: {required},   
        Description: {required},  
        SeoTitle: {},  
        SeoKeywords: {},   
        SeoDescription: {},  
        Langid:{required}, 
        Activityid:{required}, 
        Websiteid: {required},   

      }
 
  },
  created(){

  }
}
export default activitytranslations